<template lang='pug'>
  .products-index
    products-index-mobile-filter-sort(v-if='isMobile && showPriceRange')

    template(v-if='entity.attributes')
      template(v-if='entityType === "brands"')
        products-index-brand-billboards
        products-index-bestsellers-carousel(v-if='isMobile')
      template(v-else)
        products-index-top-banner(v-if='!(isMobile && (entityType === "categories" || entityType === "offers"))')
        #dy-products-index-banner

    .row.product-index-content.js-product-index-content#product-index-content
      .col-md-4.col-lg-3.left-nav.js-left-nav
        template(v-if='!isMobile && categories.length > 0')
          products-index-breadcrumbs
          products-desktop-filters
      .col-md-8.col-lg-9.js-product-list
        .shop-now-offer-card(v-if='entityType === "offers"')
          PromoCodeCard(
            :promo-code='entity'
            targetContainer='listing-page'
            :showCodeCopyLabel='true'
            :showCouponRadioButton='false'
            @viewDetailsBtnClicked='setDetailPagePromoCode'
          )
        .modal.fade#promo-codes-details-modal(
          aria-hidden='true'
          role='dialog'
          tabindex='-1'
        )
          PromoCodeDetails(
            targetContainer='listing-page'
            :promoCodeAttrs='detailPagePromoCode'
          )

        template(v-if='isMobile')
          #dy-products-index-category-navigation
          products-index-brand-info
          products-mobile-category-filters(v-if='showPriceRange')
          products-mobile-filters
        h1.mobile-product-count(v-if='entityLoaded && isMobile' v-text='mobileProductCount')

        .products-top-section(v-show='showTopSection')
          #dy-products-index-bestsellers
          products-index-bestsellers-carousel(v-if='!isMobile && entityType === "brands"')

        .index-top-action
          .search-products-count(v-if='!isMobile && entityType === "search" && !productsLoading && productsCount > 0' v-text='$t("productsFound", { number: productsCount })')
          products-sort-view

          template(v-if='!isMobile')
            template(v-if='productsCount > 0')
              pagination(:full='false' :startPage='page' :pageCount='pageCount' @setPage='setPage')
        products-grid(@setPosition='trackSearchProductPositionClicked')

        template(v-if='productsCount > 0')
          template(v-if='!productsLoading')
            pagination(:full='true' :startPage='page' :pageCount='pageCount' scrollTo='#product-index-content' :scrollOffset='-80' @setPage='setPage')

    products-index-seo-footer
    brand-json-seo-schema
    products-json-seo-schema
</template>

<i18n>
{
  "lng_en": {
    "items": "items",
    "productsFound": "%{number} products found",
    "above": "Above",
    "under": "Under",
    "brandUnavailable": "Brand not available!"
  },
  "lng_id": {
    "items": "items",
    "productsFound": "%{number} produk ditemukan",
    "above": "Above",
    "under": "Under",
    "brandUnavailable": "Merek tidak tersedia!"
  },
  "lng_th": {
    "items": "items",
    "productsFound": "พบสินค้า %{number} ชิ้น",
    "above": "Above",
    "under": "Under",
    "brandUnavailable": "ไม่มีแบรนด์นี้!"
  },
  "lng_zh": {
    "items": "items",
    "productsFound": "找到%{number}項產品",
    "above": "Above",
    "under": "Under",
    "brandUnavailable": "品牌不適用！"
  },
  "lng_ko": {
    "items": "아이템",
    "productsFound": "%{number}개의 상품을 찾았습니다. ",
    "above": "이상",
    "under": "이하",
    "brandUnavailable": "브랜드를 찾을 수 없습니다! "
  }
}
</i18n>

<script>
import { mapState, mapGetters } from 'vuex'
import { humanizePrice, dollarsToCents } from '@/modules/services/price-support'
import { productsIndexPageSizes, productsIndexDefaultSort } from '@/modules/config/catalogue'
import { pushDataLayerEvent } from '@/modules/services/gtm'
import { fullUrl } from '@/modules/services/utilities'
import { dyUtil } from '@/mixins/dyUtil'
import { scrollUtil } from '@/mixins/layoutUtil'
import { filtersMixins } from '@/mixins/filtersMixins'
import { isSsrActivated } from '@/mixins/ssrUtil'
import { isSsrListingPages } from '@/router/util/ssr_redirection'
import ProductsIndexTopBanner from './products-index-top-banner.vue'
import ProductsDesktopFilters from './products-desktop-filters.vue'
import ProductsMobileFilters from './products-mobile-filters.vue'
import ProductsMobileCategoryFilters from './products-mobile-category-filters.vue'
import ProductsGrid from './products-grid.vue'
import ProductsSortView from './products-sort-view.vue'
import Pagination from '../../shared/pagination.vue'
import ProductsIndexSeoFooter from './products-index-seo-footer.vue'
import ProductsIndexBreadcrumbs from './products-index-breadcrumbs.vue'
import ProductsIndexMobileFilterSort from './products-index-mobile-filter-sort.vue'
import ProductsIndexBrandInfo from './products-index-brand-info.vue'
import BrandJsonSeoSchema from './brand-json-seo-schema.vue'
import ProductsJsonSeoSchema from './products-json-seo-schema.vue'
import ProductsIndexBrandBillboards from './products-index-brand-billboards.vue'
import ProductsIndexBestsellersCarousel from './products-index-bestsellers-carousel.vue'
import { dynamicLoadStore } from '@/mixins/store-util'
import review from '@/store/modules/review'
import landingPage from '@/store/modules/landingPage'
import PromoCodeCard from '@/components/offers/promo-code-card'
import PromoCodeDetails from '@/components/offers/promo-code-details.vue'

export default {
  name: 'ProductsIndex',
  components: {
    ProductsIndexTopBanner,
    ProductsDesktopFilters,
    ProductsMobileFilters,
    ProductsMobileCategoryFilters,
    ProductsGrid,
    ProductsSortView,
    Pagination,
    ProductsIndexSeoFooter,
    ProductsIndexBreadcrumbs,
    ProductsIndexMobileFilterSort,
    ProductsIndexBrandInfo,
    BrandJsonSeoSchema,
    ProductsJsonSeoSchema,
    ProductsIndexBrandBillboards,
    ProductsIndexBestsellersCarousel,
    PromoCodeCard,
    PromoCodeDetails
  },

  mixins: [
    dyUtil,
    scrollUtil,
    filtersMixins,
    dynamicLoadStore({ review, landingPage })
  ],

  data () {
    return {
      unwatchPage: () => {},
      unwatchPageSize: () => {},
      unwatchSort: () => {},
      unwatchFilterBrandSlugs: () => {},
      unwatchFilterPrice: () => {},
      unwatchFilterOthers: () => {},
      unwatchFilterCustomSlugs: () => {},
      detailPagePromoCode: null
    }
  },

  computed: {
    ...mapState({
      entity: state => state.product.entity,
      entityType: state => state.product.entityType,
      entitySlug: state => state.product.entitySlug,
      entityLoaded: state => state.product.entityLoaded,
      entityPreviousRoute: state => state.product.entityPreviousRoute,
      showTopSection: state => state.product.showTopSection,
      products: state => state.product.products,
      productsCount: state => state.product.productsCount,
      productsLoading: state => state.product.productsLoading,
      page: state => state.product.page,
      pageSize: state => state.product.pageSize,
      pageCount: state => state.product.pageCount,
      sort: state => state.product.sort,
      categories: state => state.category.categories,
      filterCategorySlug: state => state.category.filterCategorySlug,
      filterBrandSlugs: state => state.product.filterBrandSlugs,
      filterPrice: state => state.product.filterPrice,
      filterCustomSlugs: state => state.product.filterCustomSlugs,
      filterOthers: state => state.product.filterOthers,
      currentUser: state => state.user.currentUser,
      availableBrands: state => state.product.availableBrands
    }),
    ...mapGetters([
      'entityRouteWithQuery',
      'entityRouteCanonical',
      'entityTypeSingular',
      'filterTypeFor'
    ]),
    isMobile: () => vueSupport.isMobile,
    mobileProductCount () {
      if (this.entityType === 'search') {
        return `${this.entitySlug} (${this.productsCount} ${this.$t('items')})`
      } else if (this.productsLoading) {
        return this.entity.attributes.label || this.entity.attributes.name || this.entity.attributes.title || this.entity.attributes.code
      } else {
        return `${this.entity.attributes.label || this.entity.attributes.name || this.entity.attributes.title || this.entity.attributes.code} (${this.productsCount} ${this.$t('items')})`
      }
    }
  },

  watch: {
    '$route' (to, from) {
      // This covers the scenario where user is browsing between categories page,
      // navigation hook will not be triggered as router considers it's same vue route,
      // so have to rely on watch to check redirecting to SSR if categories page or brand page
      if (isSsrListingPages(to, from)) {
        this.$store.commit('setProductsLoading', true)
        this.$router.go()
      } else {
        const identicalEntityType = from.meta.entityType === to.meta.entityType
        const identicalId = from.params.id === to.params.id
        const entityTypeSearch = from.meta.entityType === 'search' && to.meta.entityType === 'search'
        const identicalHash = to.hash === from.hash
        const identicalPath = to.path === from.path
        const identicalQuery = from.query.q === to.query.q
        const identicalPrice = to.query['min-price'] === from.query['min-price'] && to.query['max-price'] === from.query['max-price']
        const minMaxPriceChange = !(to.query['min-price'] || to.query['max-price']) // if only either left or right handle moves

        this.$store.commit('setFilterCategorySlug', this.$route.params.category || '')

        if (!identicalHash && identicalPath && identicalQuery && identicalPrice) {
          // when only hash changes e.g. authentication
          return
        } else if ((identicalEntityType && identicalId) || (entityTypeSearch && identicalQuery)) {
          // when only updating filterCategory
          this.updateFilters()
          this.updateSEO()
        } else if (!identicalPath) {
          // when changing category on category page
          this.fetchEntity()
          this.resetFilters()
          this.$store.dispatch('fetchFilters')
        } else {
          this.updateFilters()
        }
        this.fetchProducts()

        // prevent scrolling to top if there are price changes but not cleared filter
        if (this.isMobile || !from.query || (!identicalPrice && !minMaxPriceChange)) {
          return
        }

        this.scrollToElement()
      }
    }
  },

  beforeRouteLeave (to, from, next) {
    if (from.meta.entityType === 'search' && to.meta.entityType !== 'search') {
      this.$store.commit('setSearchQuery', '')
    }
    this.$store.commit('setEntityPreviousRoute', from)
    next()
  },

  created () {
    this.$store.commit('setFilterCategorySlug', this.$route.params.category)
    this.$store.commit('setProductsLoading', true)

    if (this.entityPreviousRoute && this.entityPreviousRoute.fullPath === this.$route.fullPath) {
      this.$store.commit('setProductsLoading', false)
      this.updateFilters()
      this.enableFilters()
      this.updateSEO()
      return
    }

    this.fetchEntity()
    this.updateFilters()

    // Should be moved to run on route change once search is linked in SPA
    if (this.entityType === 'search') {
      this.$store.commit('setSearchQuery', this.$route.query.q)
    } else {
      this.$store.commit('setSearchQuery', '')
    }

    if (this.$route.meta.entityType !== 'categories') {
      this.fetchProducts()
      this.enableFilters()
    }

    this.$store.dispatch('fetchFilters').then(() => {
      if (this.$route.meta.entityType === 'categories') {
        this.$store.dispatch('assignFilterCustomSlugs', this.$route.query)
        this.fetchProducts() // ensure custom filters are populated first
        this.enableFilters() // ensure filters are only enabled after filters are fetched
      }
    })
  },

  mounted () {
    if (this.currentUser) {
      this.$store.dispatch('fetchWishlistAndWaitlist')
      this.$store.dispatch('fetchEANotificationSubscriptions')
    }
  },

  methods: {
    setPage (page, isBottom) {
      this.$store.commit('setPage', page)
    },

    setDetailPagePromoCode (promoCode) {
      this.detailPagePromoCode = promoCode.attributes
    },

    fetchEntity () {
      this.$store.commit('setEntityLoaded', false)
      if (this.$route.meta.entityType === 'search') {
        this.$store.commit('setEntitySlug', this.$route.query.q)
        this.$store.commit('setSearchQuery', this.$route.query.q)
      } else {
        this.$store.commit('setEntitySlug', this.$route.params.id || this.$route.meta.entityId)
      }
      if (this.$route.meta.entityType) {
        this.$store.commit('setEntityType', this.$route.meta.entityType)
      }

      if (this.entityType === 'search') {
        this.$store.commit('setEntityLoaded', true)
        this.updateSEO()
        this.$nextTick(() => {
          this.updateDY()
          this.dispatchDYready()
        })
      } else {
        this.$store.dispatch('fetchEntity').then(() => {
          this.updateGTMForEntity()
          this.updateSEO()
          this.$nextTick(() => {
            this.updateDY()
          })
        }).catch(() => {
          this.handleUnavailablePage()
        })
      }
    },

    async handleUnavailablePage () {
      this.$store.commit('setPrerenderStatusCode', '404')
      this.$store.commit('setEntityPreviousRoute', null) // reset this after navigation guards are run

      if (await isSsrActivated() && this.entityType !== 'offers') {
        this.$router.push({ name: 'home-index', query: { messageType: 'error', message: this.$t('brandUnavailable') } })
      } else {
        if (this.entityType === 'brands') {
          this.$store.commit('setNotification', { type: 'error', msg: this.$t('brandUnavailable') })
        }
        this.$router.push({ name: 'home-index' })
      }
    },

    updateDY () {
      let type = ''
      let data = null

      if (this.entityType === 'categories') {
        type = 'CATEGORY'
        data = this.entitySlug.split('/')
      } else if (this.entityType === 'brands') {
        type = this.entitySlug === 'sephora-collection' ? 'OTHER' : 'CATEGORY'
        data = [this.entitySlug]
      } else if (this.entityType === 'search') {
        type = 'OTHER'
      } else {
        type = 'OTHER'
        data = [this.entitySlug]
      }

      this.initDY(type, data, this.entityType)
    },

    updateQuery () {
      const { currentRoute } = this.$router
      this.$router.replace(this.entityRouteWithQuery({ mergeQuery: currentRoute.query, hash: currentRoute.hash }))
    },

    fetchProducts () {
      let dispatchResource = 'fetchProducts'

      const productListingPages = ['brands-show', 'categories-show', 'landing-pages-sale', 'product-groups-show']
      if (vueSupport.graphQLEnabled === 'true' && productListingPages.includes(this.$route.name)) {
        dispatchResource = 'fetchProductsGraphql'
      }

      return this.$store.dispatch(dispatchResource).then(() => {
        this.updateSEO()

        dataLayer[0].list = {
          type: this.entityTypeSingular,
          total: this.productsCount,
          per_page: this.pageSize,
          sort_by: this.sort,
          page: this.page
        }

        this.$nextTick(() => {
          pushDataLayerEvent('DynamicWindowLoad')

          // has to be fired only after DynamicWindowLoad by GA event hierachy
          pushDataLayerEvent('new.list.refresh')
        })
      })
    },

    updateGTMForEntity () {
      if (this.entityTypeSingular === 'brand') {
        dataLayer[0].brand = {
          slug_url: this.entity.attributes['slug-url']
        }
      } else if (this.entityTypeSingular === 'category') {
        dataLayer[0].category = {
          slug_url: this.entity.attributes['slug-url']
        }
      } else if (this.entityType === 'search') {
        dataLayer[0].search = {
          term: this.$route.query.q
        }
      }
    },

    updateSEO () {
      // Update SEO meta attributes
      let title
      let description
      let keywords

      if (this.entityType === 'search') {
        title = 'Search'
        description = ''
        keywords = ''
      } else {
        title = this.entity.attributes['seo'] ? this.entity.attributes['seo']['page-title'] : null
        title = title || this.entity.attributes['page-title'] || this.entity.attributes['title'] || this.entity.attributes['code']

        description = this.entity.attributes['seo'] ? this.entity.attributes['seo']['meta-description'] : null
        description = description || this.entity.attributes['meta-description'] || this.entity.attributes['description']

        keywords = this.entity.attributes['seo'] ? this.entity.attributes['seo']['meta-keywords'] : null
        keywords = keywords || this.entity.attributes['meta-keywords']
      }
      // Only generate page title if it is a category page being filtered
      if (this.entityType === 'categories') {
        if (this.filterCustomSlugs.length > 0) {
          let filterValues = this.filterCustomSlugs.map(f => f.values)
          filterValues = [].concat.apply([], filterValues) // flatten array
          const filterValueNames = filterValues.map(fv => fv.attributes.value).join(', ')

          if (filterValueNames.length > 0) {
            title = `${filterValueNames} ${title}`
          }
        }

        const filteredBrands = this.filterBrandSlugs.reduce((result, brandSlug) => {
          const brand = this.availableBrands.find(brand => brand.attributes['slug-url'] === brandSlug)
          if (brand && brand.attributes) {
            result.push(brand.attributes.name)
          }
          return result
        }, [])

        // Update if filters are selected
        if (filteredBrands.length > 0) {
          title += ` by ${filteredBrands.join(', ')}`
        }

        const minPrice = this.filterPrice.min
        const maxPrice = this.filterPrice.max
        let priceRange = ''

        // Determine price range
        if (minPrice && maxPrice) {
          priceRange = `${humanizePrice(minPrice, { precision: 0 })} - ${humanizePrice(maxPrice, { precision: 0 })}`
        } else if (minPrice) {
          priceRange = `${this.$t('above')} ${humanizePrice(minPrice, { precision: 0 })}`
        } else if (maxPrice) {
          priceRange = `${this.$t('under')} ${humanizePrice(maxPrice, { precision: 0 })}`
        }

        if (priceRange !== '') {
          title += ` ${priceRange}`
        }

        const onSale = this.filterOthers.indexOf('on_sale') !== -1
        if (onSale) {
          title += ` On Sale`
        }
      }

      this.$store.commit('setSeoMetaTitle', title)
      this.$store.commit('setSeoMetaDescription', description)
      this.$store.commit('setSeoMetaKeywords', keywords)
      this.$store.commit('setSeoOgUrl', fullUrl(this.$router.resolve(this.entityRouteCanonical).href))
      this.$store.commit('setSeoUpdate', true)
    },

    enableFilters () {
      this.$nextTick(() => {
        this.unwatchPage = this.$watch('page', () => {
          this.updateQuery()
        })

        this.unwatchPageSize = this.$watch('pageSize', () => {
          this.updateQuery()
        })

        this.unwatchSort = this.$watch('sort', () => {
          this.updateQuery()
          pushDataLayerEvent('sort_by_changed', { 'sort_by_value': this.sort })
        })

        this.unwatchFilterBrandSlugs = this.$watch('filterBrandSlugs', () => {
          this.updateQuery()
        })

        this.unwatchFilterPrice = this.$watch('filterPrice', () => {
          this.updateQuery()
        })

        this.unwatchFilterOthers = this.$watch('filterOthers', () => {
          this.updateQuery()
        })

        this.unwatchFilterCustomSlugs = this.$watch('filterCustomSlugs', () => {
          this.updateQuery()
        })
      })
    },

    resetFilters () {
      this.unwatchPage()
      this.unwatchPageSize()
      this.unwatchSort()
      this.unwatchFilterBrandSlugs()
      this.unwatchFilterPrice()
      this.unwatchFilterOthers()
      this.unwatchFilterCustomSlugs()

      this.updateFilters()

      this.$store.dispatch('assignFilterCustomSlugs', null)

      this.enableFilters()
    },

    updateFilters () {
      if (this.$route.query.page) {
        this.$store.commit('setPage', parseInt(this.$route.query.page))
      } else {
        this.$store.commit('setPage', 1)
      }

      if (this.$route.query.view) {
        const pageSize = parseInt(this.$route.query.view)

        if (productsIndexPageSizes.indexOf(pageSize) !== -1) {
          this.$store.commit('setPageSize', pageSize)
        } else {
          this.updateQuery()
        }
      }

      if (this.$route.query.sort) {
        this.$store.commit('setSort', this.$route.query.sort)
      } else {
        this.$store.commit('setSort', productsIndexDefaultSort(this.entityType))
      }

      if (this.$route.query.brands) {
        this.$store.commit('setFilterBrandSlugs', this.$route.query.brands.split(','))
      } else {
        this.$store.commit('setFilterBrandSlugs', [])
      }

      if (this.$route.query['min-price']) {
        this.$store.commit('setFilterMinPrice', dollarsToCents(parseInt(this.$route.query['min-price'])))
      }
      if (this.$route.query['max-price']) {
        this.$store.commit('setFilterMaxPrice', dollarsToCents(parseInt(this.$route.query['max-price'])))
      }
      if (!this.$route.query['min-price'] && !this.$route.query['max-price']) {
        this.$store.commit('setFilterPrice', {})
      }

      if (this.$route.query.other) {
        const otherFilters = this.$route.query.other.split(',')
        // Handle SEO friendly "sale" filter
        this.$store.commit('setFilterOthers', otherFilters.map(filter => filter === 'sale' ? 'on_sale' : filter))
      } else {
        this.$store.commit('setFilterOthers', [])
      }
    },

    trackSearchProductPositionClicked (position) {
      if (this.entityType !== 'search') return

      let productPosition = position + 1
      const { query = {} } = this.$store.getters.entityRouteWithQuery()

      if (query.sort) {
        productPosition += ` | sort`
      }

      if (query['min-price'] || query['max-price'] || query.brands) {
        productPosition += ` | filter`
      }

      if (query.page) {
        productPosition += ` | page`
      }

      if (query.view) {
        productPosition += ` | view`
      }

      if (query.other) {
        productPosition += ` | other`
      }

      pushDataLayerEvent('search_results_product_position_click', {
        params: {
          search_term: query.q,
          search_position: productPosition
        }
      })
    }
  }
}
</script>

<style lang='scss'>
  .products-index-bestsellers {
    @include media-breakpoint-up(md) {
      border-bottom: 1px solid $grey;
      margin-bottom: 15px;
    }

    .product_row_title {
      text-transform: uppercase;
      text-align: center;
      margin-bottom: 10px;
    }
  }

  .search-products-count {
    margin-top: 14px;
    padding-right: 10px;
    float: left;
  }

</style>

<style lang='scss' scoped>
  .products-index {
    @include media-breakpoint-down(sm) {
      padding-top: 58px;
    }
  }

  .left-nav {
    position: relative;
  }

  .product-index-content {
    margin-top: 10px;
    margin-bottom: 20px;

    @include media-breakpoint-up(md) {
      margin-top: 20px;
    }
  }

  .index-top-action {
    display: block;
    width: 100%;
    text-align: right;

    @include media-breakpoint-up(md) {
      margin-bottom: 40px;
    }
  }

  .shop-now-offer-card {
    margin-bottom: 10px;
  }

  .mobile-product-count {
    @include font-weight-medium;
    margin-top: 10px;
    font-size: 14px;
    text-transform: none;
  }
</style>
